import { statHighlights } from '../data/storiesData';

const colorMap: Record<string, string> = {
  emerald: 'text-emerald-600 bg-emerald-50',
  teal: 'text-teal-600 bg-teal-50',
  amber: 'text-amber-600 bg-amber-50',
  rose: 'text-rose-600 bg-rose-50',
};

export default function StatsBar() {
  return (
    <section className="py-16 bg-white border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statHighlights.map((stat, i) => (
            <div key={i} className="flex flex-col items-center text-center gap-3">
              <div className={`w-14 h-14 flex items-center justify-center rounded-2xl ${colorMap[stat.color]}`}>
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <p className="text-4xl font-extrabold text-gray-900 tracking-tight">{stat.value}</p>
              <p className="text-sm text-gray-500 leading-snug max-w-[160px]">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
